/**
 * Non-chat surfaces can reserve the viewport's right edge through this
 * registry. The widest active reservation wins because right-side rails are
 * nested from the same edge rather than stacked beside one another.
 */
export const BOTTOM_RIGHT_EXCLUSION_VAR = "--bottom-right-exclusion";
export const BOTTOM_RIGHT_EXCLUSION_EVENT = "franklin:bottom-right-exclusion";

const exclusions = new Map<string, number>();

export function getBottomRightExclusion(): number {
  return Math.max(0, ...exclusions.values());
}

function publishBottomRightExclusion(): void {
  if (typeof document === "undefined") return;
  const width = getBottomRightExclusion();
  document.documentElement.style.setProperty(BOTTOM_RIGHT_EXCLUSION_VAR, `${width}px`);
  window.dispatchEvent(new CustomEvent(BOTTOM_RIGHT_EXCLUSION_EVENT, { detail: { width } }));
}

export function setBottomRightExclusion(source: string, width: number): void {
  exclusions.set(source, Math.max(0, Math.round(width)));
  publishBottomRightExclusion();
}

export function clearBottomRightExclusion(source: string): void {
  exclusions.delete(source);
  publishBottomRightExclusion();
}
